import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

export const Marked = ({ text }) => {
  let html = marked(text || '');
  DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    // safely allow target="_blank"
    if ('target' in node) {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  let sanitized = DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });

  return (
    <div
      className={`md ${html ? '' : 'empty'}`}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export const MarkedEditor = ({
  text,
  register,
  getValues,
  placeholder,
  onFocus,
  onBlur,
}) => {
  const [editing, setEditing] = useState(true);
  const [preview, setPreview] = useState(text);
  const backgroundFix = { background: '', border: 'none' };

  return (
    <div className='md-editor' style={editing ? {} : backgroundFix}>
      <a
        className='toggle'
        onClick={() => {
          setPreview(getValues);
          setEditing(!editing);
        }}
      >
        <i
          className={'fa-regular fa-' + (editing ? 'eye' : 'pen-to-square')}
        ></i>
      </a>
      {editing ? (
        <textarea
          {...register}
          placeholder={placeholder}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      ) : preview ? (
        <Marked text={preview} />
      ) : (
        <div className='md empty'></div>
      )}
    </div>
  );
};
